<app-spinner *ngIf="loading"></app-spinner>

<div *ngIf="!loading">
  <app-entity-connection-applied-tags [campaignId]="campaignId"
                                      [entityConnectionTypeId]="entityConnection.entityConnectionTypeId"
                                      [entityConnection]="entityConnection">
  </app-entity-connection-applied-tags>
</div>
